import { useState } from 'react'
import WorkflowDesigner from './WorkflowDesigner'
import { WorkflowListView } from './WorkflowListView'
import { DEFAULT_TENANT_ID } from 'shared/utils/tenantContext'

interface WorkflowConfigurationProps {
  currentUser?: {
    name?: string | null
    tenantId?: string | null
  }
}

export function WorkflowConfiguration({ currentUser }: WorkflowConfigurationProps) {
  const tenantId = currentUser?.tenantId ?? DEFAULT_TENANT_ID
  const [view, setView] = useState<'list' | 'designer'>('list')
  const [selectedWorkflowVersionId, setSelectedWorkflowVersionId] = useState<string | null>(null)

  const openDesigner = (workflowVersionId: string | null) => {
    setSelectedWorkflowVersionId(workflowVersionId)
    setView('designer')
  }

  if (view === 'designer') {
    return (
      <WorkflowDesigner
        currentUser={currentUser}
        initialWorkflowVersionId={selectedWorkflowVersionId}
        onBack={() => setView('list')}
      />
    )
  }

  return <WorkflowListView tenantId={tenantId} onOpenDesigner={(workflowVersionId) => openDesigner(workflowVersionId)} />
}

export default WorkflowConfiguration
